export default __webpack_public_path__ + "static/media/blackborder.43eda340.png";